import React from 'react';
import styled from 'styled-components';
import useChartPreference from '../hooks/useChartPreference';
import SouthIndianChart from '../../charts/SouthIndianChart';
import NorthIndianChart from '../../charts/NorthIndianChart';

const Wrapper = styled.div`
  position:relative;
  background:${p => p.theme.colors.surface};
  border:1px solid ${p => p.theme.colors.border};
  border-radius:${p => p.theme.radius.md}px;
  box-shadow:${p => p.theme.shadow.card};
`;
const ToggleBtn = styled.button`
  position:absolute;top:8px;right:8px;z-index:2;
  width:32px;height:32px;border-radius:50%;
  border:1px solid ${p => p.theme.colors.border};
  background:${p => p.theme.colors.surface};
  cursor:pointer;font-size:${p => p.theme.typography.sizes.xs};
  font-weight:${p => p.theme.typography.weights.bold};
  display:flex;align-items:center;justify-content:center;
  box-shadow:${p => p.theme.shadow.card};
  &:hover{background:${p => p.theme.colors.background};}
`;
const ChartTitle = styled.h4`
  font-size:${p => p.theme.typography.sizes.md};
  color:${p => p.theme.colors.text.primary};
  margin:0 0 8px;
  font-weight:${p => p.theme.typography.weights.semibold};
  text-align:center;
  padding:${p => p.theme.spacing[3]}px ${p => p.theme.spacing[3]}px 0;
`;

export default function ChartContainer({ chartData, title, isNavamsa, loc, showToggle = true }) {
  const { style, toggle } = useChartPreference();
  const Chart = style === 'north' ? NorthIndianChart : SouthIndianChart;

  return (
    <Wrapper>
      {title && <ChartTitle>{title}</ChartTitle>}
      {showToggle && (
        <ToggleBtn onClick={toggle} title={`Switch to ${style === 'south' ? 'North' : 'South'} Indian`}
          aria-label="Switch chart style">
          {style === 'south' ? 'N' : 'S'}
        </ToggleBtn>
      )}
      <Chart chartData={chartData} isNavamsa={isNavamsa} loc={loc} />
    </Wrapper>
  );
}
